import { AxiosInstance } from 'axios';
import {
  UserBaseInfoInterface,
  UserEditInterface, UserInterface,
  UserRegisterInterface,
  UserRepoInterface, UserResponseInterface,
} from '@/services/Users/Interfaces';

export default class UsersRepo implements UserRepoInterface {
  constructor(
    protected axios: AxiosInstance,
  ) {
  }

  public async getAllUsers(page?: number, search?: string): Promise<[UserInterface[], number]> {
    const params: string [] = [];
    if (page) {
      params.push(`page=${page}`);
    }

    if (search) {
      params.push(`search=${search.trim()}`);
    }

    const res = await this.axios.get(`/auth/users?${params.join('&')}`);

    return res.data;
  }

  public async createUser(userDetails: UserRegisterInterface): Promise<UserResponseInterface> {
    const res = await this.axios.post('/auth/users', userDetails);
    return res.data;
  }

  public async getUser(userId: string): Promise<UserResponseInterface> {
    const res = await this.axios.get(`/auth/users/${userId}`);
    return res.data;
  }

  public async editUser(userId: string, userData: UserEditInterface): Promise<void> {
    await this.axios.patch(`/auth/users/${userId}`, { userData });
  }

  public async deleteUser(userId: string): Promise<boolean> {
    await this.axios.delete('/auth/users', {
      data: {
        id: userId,
      },
    });

    return true;
  }

  public async forceLogout(userId: string): Promise<void> {
    await this.axios.post('/auth/forceLogout', { userId });
  }

  public async getQaUsers(): Promise<UserBaseInfoInterface[]> {
    const res = await this.axios.get('/auth/users/qa');

    return res.data;
  }

  public async getQaManagers(): Promise<UserBaseInfoInterface[]> {
    const res = await this.axios.get('/auth/users/qa-managers');

    return res.data;
  }

  public async getShiftManagers(): Promise<UserBaseInfoInterface[]> {
    const res = await this.axios.get('/auth/users/shift-managers');

    return res.data;
  }

  public async getUsersByEmails(emails: string[]): Promise<UserBaseInfoInterface[]> {
    const res = await this.axios.post('/auth/users/emails', emails);

    return res.data;
  }

  public async getUsersByIds(ids: string[]): Promise<UserBaseInfoInterface[]> {
    const res = await this.axios.post('/auth/users/ids', ids);

    return res.data;
  }

  public async getUsersByDepartment(department: string): Promise<UserInterface[]> {
    const res = await this.axios.get(`/auth/users/department/${department}`);

    return res.data;
  }

  public async getUsersByScope(scope: string): Promise<UserBaseInfoInterface[]> {
    const res = await this.axios.get(`/auth/users/scopes/${scope}`);

    return res.data;
  }

}
